import React, { useContext, useState } from 'react';
import { FormControl, FormLabel, Input, Button, Text, Box, Alert, AlertIcon, InputGroup } from '@chakra-ui/react';
import ReCAPTCHA from 'react-google-recaptcha';
import fetchData from './utils/Util';
import { ConfigContext } from './utils/Config';
import { useTranslation } from 'react-i18next';

const ForgotPassword = () => {
  const { t, i18n } = useTranslation();
  const config = useContext(ConfigContext);
  const [email, setEmail] = useState('');
  const [captchaValue, setCaptchaValue] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      if (!captchaValue) {
        setError(t('forgotPassword.captchaError'));
        return;
      }

      const response = await fetchData(
        `${config.backendUrl}/api/user_password`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            language: i18n.language === 'zh' ? 'zh-hans' : i18n.language,
            mail: email,
            site: config.siteName,
          }),
        }
      );

      if (response.ok) {
        setSuccess(t('forgotPassword.successMessage'));
      } else {
        const errorData = await response.json();
        setError(errorData.title || t('forgotPassword.errorMessage'));
      }
    } catch (error) {
      setError(t('forgotPassword.generalError'));
    }
  };

  return (
    <Box className="forgot-password">
       <h1>{t('forgotPassword.title')}</h1>
      <Text marginBottom="10px">
        {t('forgotPassword.instruction1')}
      </Text>
      <Text marginBottom="30px">
        {t('forgotPassword.instruction2')}
      </Text>

      {error && (
        <Alert status="error" marginBottom="20px">
          <AlertIcon />
          {error}
        </Alert>
      )}

      {success && (
        <Alert status="success" marginBottom="20px">
          <AlertIcon />
          {success}
        </Alert>
      )}

      <form onSubmit={handleSubmit}>
        <FormControl marginBottom="20px" isRequired>
          <FormLabel>{t('forgotPassword.emailLabel')}</FormLabel>
          <InputGroup>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('forgotPassword.emailPlaceholder')}
              required
            />
          </InputGroup>
        </FormControl>

        <Box marginBottom="30px">
          <ReCAPTCHA
            sitekey={config.recaptchaKey}
            hl={i18n.language} // Pass the language code here
            onChange={(token) => setCaptchaValue(token)}
          />
        </Box>

        <Text className="help-text" dangerouslySetInnerHTML={{ __html: t('register.requiredFields', { asterisk: '<span style="color: red;">*</span>' }) }} />

        <Button type="submit" colorScheme="blue">{t('forgotPassword.submitButton')}</Button>
      </form>
    </Box>
  );
};

export default ForgotPassword;